import { createAction, props } from '@ngrx/store';
import { OverTime, Tags } from '../../modals/UsageInsights';

export class RecognitionQueryParams {
    pageIndex: number;
    pageSize: number;
}

export const overTimeRequested = createAction(
    '[USAGE_INSIGHTS] Over Time Requested'
);

export const overTimeLoaded = createAction(
    '[USAGE_INSIGHTS] Over Time Loaded',
    props<{ data: OverTime[] }>()
);

export const overTimeLoadError = createAction(
    '[USAGE_INSIGHTS] Over Time Load Error',
    props<{ errorMessage: string }>()
);

export const tagRequested = createAction(
    '[USAGE_INSIGHTS] Tag Requested',
    props<{ queryParam: any }>()
);

export const tagLoaded = createAction(
    '[USAGE_INSIGHTS] Tag Loaded',
    props<{ data: Tags[] }>()
);

export const tagLoadError = createAction(
    '[USAGE_INSIGHTS] Tag Loading Error',
    props<{ errorMessage: string }>()
);

export const tagUpdateRequested = createAction(
    '[USAGE_INSIGHTS] Tag Update Requested',
    props<{ queryParam: any }>()
);

export const tagUpdated = createAction(
    '[USAGE_INSIGHTS] Tag Updated',
    props<{ data: Tags[] }>()
);

export const starsRequested = createAction(
    '[USAGE_INSIGHTS] Stars Requested'
);

export const starsLoaded = createAction(
    '[USAGE_INSIGHTS] Stars Loaded',
    props<{ data: any }>()
);

export const starsLoadError = createAction(
    '[USAGE_INSIGHTS] Stars Loading Error',
    props<{ errorMessage: any }>()
);